import React from "react";
import { INFO_TITLE } from "../../util/constants";
import { Grid, IconButton } from "@mui/material";
import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import SlideUpTransition from "./SlideUpTransition";
import PropTypes from "prop-types";
import CloseIcon from "@mui/icons-material/Close";
import ShiftBidPDFExport from "../../pages/bid/ShiftBidPDFExport";
import { BID_STATUS } from "../../util/bid/bidConstants";

const InfoDialog = (props) => {
  return (
    <Dialog
      PaperProps={{
        sx: {
          width: "600px",
          maxWidth: "90vw",
          margin: "auto",
          whiteSpace: "pre-line",
        },
      }}
      open={props.isDialogOpen}
      TransitionComponent={SlideUpTransition}
      keepMounted
      data-testid="info-dialog"
    >
      <DialogTitle>{props.title ? props.title : INFO_TITLE}</DialogTitle>
      <IconButton
        aria-label="close"
        onClick={props.handleCloseClicked}
        sx={{
          position: "absolute",
          right: 8,
          top: 8,
          color: (theme) => theme.palette.grey[500],
        }}
      >
        <CloseIcon />
      </IconButton>
      <DialogContent
        sx={{
          paddingTop: 0,
        }}
      >
        <DialogContentText component={"div"}>
          <Grid container>
            <Grid item xs={12}>
              {props.message.__html ? <span dangerouslySetInnerHTML={props.message} /> : props.message}
            </Grid>
          </Grid>
          {!props.isDesktopView && (
            <Grid container alignItems={"center"} justifyContent={"center"} marginTop={"15px"}>
              <ShiftBidPDFExport
                isDesktopView={false}
                bidLines={props.bidLines}
                selectedBidLines={props.selectedBidLines}
                eid={props.eid}
                bidChoiceData={props.bidChoiceData}
                lastSubmittedTimestamp={props.lastSubmittedTimestamp}
                isBidLineExportAllowed={props.bidChoiceData?.status === BID_STATUS.OPEN}
                useAssignmentForEmp={props.useAssignmentForEmp}
              />
            </Grid>
          )}
        </DialogContentText>
      </DialogContent>
    </Dialog>
  );
};

InfoDialog.propTypes = {
  isDialogOpen: PropTypes.bool.isRequired,
  bidLines: PropTypes.array,
  selectedBidLines: PropTypes.array,
  eid: PropTypes.string,
  bidChoiceData: PropTypes.object,
  lastSubmittedTimestamp: PropTypes.number,
  useAssignmentForEmp: PropTypes.bool,
  title: PropTypes.string,
  message: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  handleCloseClicked: PropTypes.func,
  isDesktopView: PropTypes.bool,
};

export default InfoDialog;
